<template>
  <div>
    <!-- pc -->
    <div style="" class="bg" v-if="isMobile == 'null'">
      <div
        class="header"
        :style="{
          backgroundColor: gotop || !isHome ? 'rgba(0,0,0,0.8)' : 'transparent',
        }"
      >
        <div style="flex: 1">
          <img
            src="../assets/imgs/logo.png"
            class="logo"
            :class="{ 'logo-top': gotop || !isHome }"
            @click="tohome"
          />
        </div>
        <div
          @click="searchbox()"
          :style="{ width: searchboxshow ? '12.5rem' : '2.2rem' }"
          style="
            border: 1px solid #fff;
            display: flex;
            align-items: center;
            border-radius: 2rem;
            width: 12.5rem;
            height: 2.1875rem;
            padding: 0.5rem;
            transition: 1s;
            position: relative;
            background-color: #323232;
            margin-right: 1rem;
            z-index: 10;
          "
        >
          <!-- <div class="search-text"> -->
          <input
            type="text"
            style="
              border: none;
              color: #fff;
              background-color: transparent;
              font-weight: 400;
              line-height: 0;
              font-size: 0.8rem;
              padding-left: 0.5rem;
            "
            placeholder="Search"
            v-model="searchkeyword"
            class="search-input"
            :style="{
              width: searchboxshow ? '100%' : '0%',
              display: searchboxshow ? 'block' : 'none',
            }"
            @keydown.enter="tosearch()"
          />
          <!-- </div> -->
          <img
            src="../assets/imgs/search.svg"
            style="
              width: 1rem;
              height: 1rem;
              position: absolute;
              right: 0.5rem;
              cursor: pointer;
            "
            @click="tosearch()"
          />
        </div>

        <!-- <img src="../assets/imgs/lang.png" class="lang-icon" v-if="langshow"> -->
        <div
          class="trans"
          id="trans"
          style="display: flex; align-items: center; justify-content: center"
        ></div>
        <div
          style="display: flex; align-items: center; cursor: pointer"
          v-if="!islogin"
        >
          <div
            class="login-button"
            style="background: #fff; margin-left: 12px"
            @click="login(1)"
          >
            Log in
          </div>
          <div
            class="login-button btn-cyan-liner"
            style="margin-left: 0.6875rem; margin-right: 1.5rem"
            @click="login(2)"
          >
            Sign up
          </div>
        </div>
        <div
          v-if="islogin && user"
          style="position: relative; margin-right: 3rem; margin-left: 1rem"
          @click="sidemenushow()"
        >
          <div
            :style="{
              backgroundImage: 'url(' + user.avatar + ')',
              width: !gotop && isHome ? '2.2rem' : '2rem',
              height: !gotop && isHome ? '2.2rem' : '2rem',
            }"
            class="avatar"
            style="border: 1px solid #fff; cursor: pointer; position: relative"
          >
            <div
              style="
                position: absolute;
                right: -0.3rem;
                top: -0.3rem;
                border-radius: 50%;
                width: 1rem;
                height: 1rem;
                background-color: #f00;
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.6rem;
              "
              v-show="unreadcount"
            >
              {{ unreadcount }}
            </div>
          </div>
        </div>
      </div>

      <div
        class="title"
        :style="{ position: gotop || !isHome ? 'fixed' : 'initial' }"
      >
        <div
          class="title-text"
          :class="{ 'title-top': gotop || !isHome }"
          style="cursor: pointer"
          @click="tohome"
        >
          Home
        </div>
        <div
          class="title-text"
          @mouseenter="changeItemBox(1)"
          @mouseleave="changeItemBox(0)"
          :class="{ 'title-top': gotop || !isHome }"
        >
          <div
            :class="{ 'title-color': itemActive == 1 }"
            @click="tonewsmain"
            style="cursor: pointer"
          >
            Information
            <img
              :src="
                itemActive == 1
                  ? require('../assets/imgs/arrow-down-light.png')
                  : require('../assets/imgs/arrow-down.png')
              "
              class="arrow-down"
              :style="{ transform: itemActive == 1 ? 'rotate(180deg)' : '' }"
            />
          </div>

          <div
            class="item-box fadeIn animated"
            style="display: flex; flex-direction: row; width: 40rem"
            v-if="itemActive == 1"
          >
            <div style="margin-right: 1rem">
              <div
                class="item-title"
                style="cursor: pointer"
                @click="toNewslist({ title: 0, item: 0 })"
              >
                Industry Information
              </div>
              <div class="item-text" @click="toNewslist({ title: 0, item: 0 })">
                Sanitary Care
              </div>
              <div class="item-text" @click="toNewslist({ title: 0, item: 1 })">
                Tourism Care
              </div>
              <div class="item-text" @click="toNewslist({ title: 0, item: 2 })">
                Pet Care
              </div>
              <div class="item-text" @click="toNewslist({ title: 0, item: 3 })">
                Food Care
              </div>
              <div class="item-text" @click="toNewslist({ title: 0, item: 4 })">
                Home Care
              </div>
            </div>
            <div style="margin-right: 1rem; width: 11rem">
              <div
                class="item-title"
                style="cursor: pointer"
                @click="toNewslist({ title: 1, item: 0 })"
              >
                Events
              </div>
              <div class="item-text" @click="toNewslist({ title: 1, item: 0 })">
                Latest News On GCI
              </div>
              <div class="item-text" @click="toNewslist({ title: 1, item: 1 })">
                Exhibitions & Forums
              </div>
            </div>
            <div style="margin-right: 1rem">
              <div
                class="item-title"
                style="cursor: pointer"
                @click="toNewslist({ title: 2, item: 0 })"
              >
                GCI Insights
              </div>
              <div class="item-text" @click="toNewslist({ title: 2, item: 0 })">
                GCI Insights
              </div>
            </div>
          </div>
        </div>
        <div
          class="title-text"
          @mouseenter="changeItemBox(2)"
          @mouseleave="changeItemBox(0)"
          :class="{ 'title-top': gotop || !isHome }"
        >
          <div
            :class="{ 'title-color': itemActive == 2 }"
            @click="tocirclemain"
            style="cursor: pointer"
          >
            Discussion
            <img
              :src="
                itemActive == 2
                  ? require('../assets/imgs/arrow-down-light.png')
                  : require('../assets/imgs/arrow-down.png')
              "
              class="arrow-down"
              :style="{ transform: itemActive == 2 ? 'rotate(180deg)' : '' }"
            />
          </div>

          <div
            class="item-box fadeIn animated"
            style=""
            v-show="itemActive == 2"
            style="width: 10rem"
          >
            <div class="item-title">Topics</div>
            <div class="item-text" @click="tocircletopic(1)">Sanitary Care</div>
            <div class="item-text" @click="tocircletopic(2)">Tourism Care</div>
            <div class="item-text" @click="tocircletopic(4)">Pet Care</div>
            <div class="item-text" @click="tocircletopic(3)">Food Care</div>
            <div class="item-text" @click="tocircletopic(5)">Home Care</div>
          </div>
        </div>
        <div
          class="title-text"
          @mouseenter="changeItemBox(3)"
          @mouseleave="changeItemBox(0)"
          :class="{ 'title-top': gotop || !isHome }"
        >
          <div :class="{ 'title-color': itemActive == 3 }">
            Services
            <img
              :src="
                itemActive == 3
                  ? require('../assets/imgs/arrow-down-light.png')
                  : require('../assets/imgs/arrow-down.png')
              "
              class="arrow-down"
              :style="{ transform: itemActive == 3 ? 'rotate(180deg)' : '' }"
            />
          </div>

          <div
            class="item-box fadeIn animated"
            style="display: flex; flex-direction: row; width: 25rem"
            v-if="itemActive == 3"
          >
            <div style="margin-right: 1rem">
              <div class="item-title">Consultant</div>
              <div class="item-text" @click="toexpert">
                Experts Appointments
              </div>
            </div>
            <div>
              <div class="item-title">Service Providers</div>
              <div class="item-text" @click="tosupplierlist">
                Service Providers Updates
              </div>
            </div>
          </div>
        </div>
        <div
          class="title-text"
          @mouseenter="changeItemBox(4)"
          @mouseleave="changeItemBox(0)"
          :class="{ 'title-top': gotop || !isHome }"
        >
          <div
            :class="{ 'title-color': itemActive == 4 }"
            @click="todemandmain()"
            style="cursor: pointer"
          >
            Demands Publishing
            <img
              :src="
                itemActive == 4
                  ? require('../assets/imgs/arrow-down-light.png')
                  : require('../assets/imgs/arrow-down.png')
              "
              class="arrow-down"
              :style="{ transform: itemActive == 4 ? 'rotate(180deg)' : '' }"
            />
          </div>

          <div
            class="item-box fadeIn animated"
            style=""
            v-show="itemActive == 4"
            style="width: 14rem"
          >
            <div class="item-title">Demands Publishing</div>
            <div
              class="item-text"
              @click="todemandmain(demand.id)"
              v-for="(demand, demandindex) in demanddata"
              :key="demandindex"
            >
              {{ demand.title }}
            </div>
          </div>
        </div>
        <div
          class="title-text"
          @mouseenter="changeItemBox(5)"
          @mouseleave="changeItemBox(0)"
          :class="{ 'title-top': gotop || !isHome }"
        >
          <div
            :class="{ 'title-color': itemActive == 5 }"
            @click="toProduct()"
            style="cursor: pointer"
          >
            Selection Hub
            <img
              :src="
                itemActive == 5
                  ? require('../assets/imgs/arrow-down-light.png')
                  : require('../assets/imgs/arrow-down.png')
              "
              class="arrow-down"
              :style="{ transform: itemActive == 5 ? 'rotate(180deg)' : '' }"
            />
          </div>

          <div
            class="item-box fadeIn animated"
            style=""
            v-show="itemActive == 5"
            style="width: 11rem"
          >
            <div class="item-title">Product</div>
            <div
              class="item-text"
              @click="toProduct(demand.id)"
              v-for="(demand, demandindex) in categories"
              :key="demandindex"
            >
              {{ demand.name }}
            </div>
          </div>
        </div>
        <!-- <div class="title-text" @mouseenter="changeItemBox(6)" @mouseleave="changeItemBox(0)" :class="{ 'title-top': gotop||!isHome }">
					<div :class="{ 'title-color': itemActive == 6 }" @click="toabout()" style="cursor: pointer;	">
						About Us 
					</div>
				</div> -->
        <!-- <img src="../assets/imgs/title-more.png" alt="" style="width: 58px;height: 58px"> -->
      </div>
    </div>

    <!-- totop -->
    <div
      style="
        position: fixed;
        right: 1rem;
        bottom: 7rem;
        display: flex;
        flex-direction: column;
        z-index: 5;
      "
      v-if="totopshow"
    >
      <img
        src="../assets/imgs/kefu.svg"
        style="
          width: 3rem;
          height: 3rem;
          margin-bottom: 0.5rem;
          cursor: pointer;
          border-radius: 50%;
          padding: 0.5rem;
        "
        class="btn-cyan-liner"
        @click="tokefu"
      />
      <img
        src="../assets/imgs/totop.svg"
        style="
          width: 3rem;
          height: 3rem;
          cursor: pointer;
          border-radius: 50%;
          padding: 0.7rem;
        "
        class="btn-cyan-liner"
        @click="toTop"
        v-if="gotop"
      />
    </div>

    <!-- mobile -->
    <div class="mobile-bg" v-if="isMobile != 'null'">
      <div :style="{ position }" style="left: 0; top: 0; z-index: 999">
        <div
          style="
            width: 100vw;
            padding: 1rem;
            display: flex;
            align-items: center;
            background-color: rgba(0, 0, 0, 0.9);
          "
        >
          <div style="flex: 1">
            <img
              src="../assets/imgs/logo.png"
              style="width: 7.5rem; height: 2.5rem"
              @click="tohome"
              v-show="!sliderboxshow"
            />
            <div
              class="trans"
              id="trans"
              style="
                display: flex;
                align-items: center;
                justify-content: flex-start;
              "
              v-show="sliderboxshow"
            ></div>
          </div>
          <!-- <img src="../assets/imgs/search-mobile.png" style="width: 2rem;height: 2rem;margin-right: 0.5rem;"> -->

          <div
            @click="searchbox()"
            :style="{ width: searchboxshow ? '8rem' : '2.2rem' }"
            style="
              border: 1px solid #fff;
              display: flex;
              align-items: center;
              border-radius: 2rem;
              height: 2.1875rem;
              padding: 0.5rem;
              transition: 1s;
              position: relative;
            "
            class="modile-search-box"
          >
            <!-- <div class="search-text"> -->
            <input
              type="text"
              style="
                border: none;
                background-color: transparent;
                color: #fff;
                font-weight: 400;
                line-height: 0;
                font-size: 0.8rem;
                padding-left: 0.5rem;
              "
              placeholder="Search"
              v-model="searchkeyword"
              class="search-box-input"
              :style="{
                width: searchboxshow ? '100%' : '0%',
                display: searchboxshow ? 'block' : 'none',
              }"
            />
            <!-- </div> -->
            <img
              src="../assets/imgs/search.svg"
              style="
                width: 1rem;
                height: 1rem;
                position: absolute;
                right: 0.5rem;
              "
              @click="tosearch()"
            />
          </div>
          <!-- <img src="../assets/imgs/title-more.png" style="width: 3rem;height: 3rem" @click="sliderboxshow=!sliderboxshow"> -->
          <div
            :class="{
              slicknav_collapsed: sliderboxshow,
              slicknav_open: !sliderboxshow,
            }"
            @click="sliderboxshow = !sliderboxshow"
            style="width: 1.5rem; height: 1.5rem; margin: 0 1rem"
          >
            <span class="menu-icon">
              <span class="menu-icon-inner"></span>
            </span>
          </div>
        </div>
        <div v-show="sliderboxshow">
          <div
            style="
              background-color: rgba(0, 0, 0, 0.9);
              z-index: 999;
              display: flex;
              flex-direction: column;
            "
            class="fadeInDown animated menu-box"
          >
            <div
              style="
                padding: 0 2rem 2rem;
                display: flex;
                flex-direction: column;
                flex: 1;
              "
            >
              <div style="display: flex; flex-direction: column">
                <div>
                  <div class="slider-title" @click="tohome">Home</div>
                </div>
                <div>
                  <div
                    class="slider-title"
                    @click="changeItemBox(1)"
                    :class="{ 'title-color': itemActive == 1 }"
                  >
                    Information
                    <img
                      :src="
                        itemActive == 1
                          ? require('../assets/imgs/arrow-down-light.png')
                          : require('../assets/imgs/arrow-down.png')
                      "
                      :style="{
                        transform: itemActive == 1 ? 'rotate(180deg)' : '',
                      }"
                      style="width: 1rem; height: 1rem; margin-left: 0.3rem"
                    />
                  </div>

                  <div class="slider-item" style="" v-show="itemActive == 1">
                    <div
                      class="item-title"
                      @click="toNewslist({ title: 0, item: 0 })"
                    >
                      Industry Information
                    </div>
                    <div
                      class="item-title"
                      @click="toNewslist({ title: 1, item: 0 })"
                    >
                      Events
                    </div>
                    <div
                      class="item-title"
                      @click="toNewslist({ title: 2, item: 0 })"
                    >
                      GCI Insights
                    </div>
                  </div>
                </div>
                <div>
                  <div
                    class="slider-title"
                    @click="changeItemBox(2)"
                    :class="{ 'title-color': itemActive == 2 }"
                  >
                    Discussion
                    <img
                      :src="
                        itemActive == 2
                          ? require('../assets/imgs/arrow-down-light.png')
                          : require('../assets/imgs/arrow-down.png')
                      "
                      :style="{
                        transform: itemActive == 2 ? 'rotate(180deg)' : '',
                      }"
                      style="width: 1rem; height: 1rem; margin-left: 0.3rem"
                    />
                  </div>

                  <div class="slider-item" style="" v-show="itemActive == 2">
                    <div class="item-title" @click="tocircletopic(1)">
                      Sanitary care
                    </div>
                    <div class="item-title" @click="tocircletopic(2)">
                      Tourism care
                    </div>
                    <div class="item-title" @click="tocircletopic(4)">
                      Pet care
                    </div>
                    <div class="item-title" @click="tocircletopic(3)">
                      Food care
                    </div>
                    <div class="item-title" @click="tocircletopic(5)">
                      Home care
                    </div>
                  </div>
                </div>
                <div>
                  <div
                    class="slider-title"
                    @click="changeItemBox(3)"
                    :class="{ 'title-color': itemActive == 3 }"
                  >
                    Services
                    <img
                      :src="
                        itemActive == 3
                          ? require('../assets/imgs/arrow-down-light.png')
                          : require('../assets/imgs/arrow-down.png')
                      "
                      :style="{
                        transform: itemActive == 3 ? 'rotate(180deg)' : '',
                      }"
                      style="width: 1rem; height: 1rem; margin-left: 0.3rem"
                    />
                  </div>

                  <div class="slider-item" style="" v-show="itemActive == 3">
                    <div class="item-title" @click="toexpert">Consultant</div>
                    <div class="item-title" @click="tosupplierlist">
                      Service Providers
                    </div>
                  </div>
                </div>
                <div>
                  <div
                    class="slider-title"
                    @click="changeItemBox(4)"
                    :class="{ 'title-color': itemActive == 4 }"
                  >
                    Demands Publishing
                    <img
                      :src="
                        itemActive == 4
                          ? require('../assets/imgs/arrow-down-light.png')
                          : require('../assets/imgs/arrow-down.png')
                      "
                      :style="{
                        transform: itemActive == 4 ? 'rotate(180deg)' : '',
                      }"
                      style="width: 1rem; height: 1rem; margin-left: 0.3rem"
                    />
                  </div>

                  <div class="slider-item" style="" v-show="itemActive == 4">
                    <div
                      class="item-title"
                      @click="todemandmain(demand.id)"
                      v-for="(demand, demandindex) in demanddata"
                      :key="demandindex"
                    >
                      {{ demand.title }}
                    </div>
                  </div>
                </div>
                <div>
                  <div
                    class="slider-title"
                    @click="changeItemBox(5)"
                    :class="{ 'title-color': itemActive == 5 }"
                  >
                    All Products
                    <img
                      :src="
                        itemActive == 5
                          ? require('../assets/imgs/arrow-down-light.png')
                          : require('../assets/imgs/arrow-down.png')
                      "
                      :style="{
                        transform: itemActive == 5 ? 'rotate(180deg)' : '',
                      }"
                      style="width: 1rem; height: 1rem; margin-left: 0.3rem"
                    />
                  </div>

                  <div class="slider-item" style="" v-show="itemActive == 5">
                    <div
                      class="item-title"
                      @click="toProduct(demand.id)"
                      v-for="(demand, demandindex) in categories"
                      :key="demandindex"
                    >
                      {{ demand.name }}
                    </div>
                  </div>
                </div>
                <div>
                  <div
                    class="slider-title"
                    @click="toabout()"
                    :class="{ 'title-color': itemActive == 6 }"
                  >
                    About Us
                  </div>
                </div>

                <div
                  style="
                    padding: 1rem 0 0rem;
                    border-top: 1px solid rgba(255, 255, 255, 0.3);
                    margin-top: 1rem;
                  "
                >
                  <div
                    style="display: flex; align-items: center"
                    v-if="!islogin"
                  >
                    <div
                      class="login-button"
                      style="background: #fff"
                      @click="tomlogin(0)"
                    >
                      Log in
                    </div>
                    <div
                      class="login-button"
                      style="
                        background: linear-gradient(
                          270deg,
                          #23f8d2 0%,
                          #23f7d3 49%,
                          #23e4eb 100%
                        );
                        margin-left: 0.6875rem;
                        margin-right: 5rem;
                      "
                      @click="tomlogin(2)"
                    >
                      Sign up
                    </div>
                  </div>

                  <div
                    v-if="islogin && user"
                    style="
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                    "
                  >
                    <div
                      :style="{ backgroundImage: 'url(' + user.avatar + ')' }"
                      class="avatar"
                      style="width: 3rem; height: 3rem"
                      @click="touser(5)"
                    ></div>

                    <li
                      style="
                        font-size: 1rem;
                        color: #999;
                        display: flex;
                        align-items: center;
                        font-weight: bold;
                      "
                      @click="signout"
                    >
                      Sign out
                    </li>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            style="z-index: 998; width: 100vw; height: 100vh"
            @click="sliderboxshow = false"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
import loadJs from "../assets/js/loadJs.js";
import Cookies from "js-cookie";
export default {
  data() {
    return {
      itemActive: 0,
      gotop: false,
      langbox: 0,
      searchboxshow: false,
      isMobile: false,
      sliderboxshow: false,
      islogin: false,
      user: null,
      defaultavatar: require("../assets/imgs/avatar.svg"),
      userbox: 0,
      searchkeyword: "",
      totopshow: true,
      langshow: false,
      unreadcount: 0,
      indexdata: {},
      demanddata: [],
      categories: [],
    };
  },
  props: {
    isHome: Boolean,
    position: {
      type: String,
      default: "fixed",
    },
  },
  components: {},
  filters: {},
  methods: {
    async getdata() {
      let res3 = await this.$get("/categories");
      this.categories = res3.data.items;
    },
    tokefu() {
      window.open(this.indexdata.whatsapp);
    },
    tomlogin(i) {
      this.$router.push({ name: "mlogin", query: { type: i } });
    },
    touser(t) {
      this.$router.push({ name: "user", query: { type: t } });
      location.reload();
    },
    changeItemBox(i) {
      if (i == this.itemActive) {
        this.itemActive = 0;
      } else {
        this.itemActive = i;
      }
    },
    handleScroll() {
      //注意不同浏览器之间的兼容性
      let scrolltop =
        document.documentElement.scrollTop || document.body.scrollTop;
      scrolltop > 30 ? (this.gotop = true) : (this.gotop = false);
    },
    toTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop =
          document.documentElement.scrollTop =
          top -=
            50;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    },
    changelangbox(i) {
      this.langbox = i;
    },
    searchbox() {
      // if(this.searchkeyword||!searchboxshow){
      // if(!this.searchkeyword){
      // 	this.searchboxshow = !this.searchboxshow
      // }
      // }else{
      // 	this.searchboxshow = 0
      // }
    },
    changesliderbox(i) {
      this.sliderboxshow = true;
    },
    tonewsmain() {
      this.$router.push({ name: "newsmain" });
    },
    toNewslist(obj) {
      let params = obj;
      localStorage.setItem("newslist", JSON.stringify(params));
      this.$router.push({ name: "newslist" }).catch((data) => {});
      location.reload();
    },
    login(i) {
      console.info("login type" + i);
      localStorage.setItem("logintype", i);
      this.$bus.$emit("login", true);
    },
    tohome() {
      this.$router.push({ name: "home" });
    },
    signout() {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      this.$router.push({ name: "home" });
      location.reload();
    },
    tocirclemain() {
      this.$router.push({ name: "circlemain" });
    },
    toexpert() {
      this.$router.push({ name: "expert" });
    },
    tosupplierlist() {
      this.$router.push({ name: "supplierlist" });
    },
    getuser() {
      this.request({
        method: "get",
        url: "/gci/user/info",
      })
        .then((res) => {
          this.user = res.data;
          // console.info(this.user)
          localStorage.setItem("user", JSON.stringify(this.user));
        })
        .catch((error) => {
          console.error(error.response);
        });
    },
    tocircletopic(id) {
      this.$router.push({ name: "circletopic", query: { id: id } });
      location.reload();
    },
    tosearch() {
      if (this.searchkeyword != "") {
        this.$router.push({
          name: "searchmain",
          query: {
            type: 1,
            keyword: this.searchkeyword,
          },
        });
        location.reload();
      } else {
        this.searchboxshow = !this.searchboxshow;
      }
    },
    toabout() {
      this.$router.push({ name: "about" });
    },
    todemandmain(id) {
      this.$router.push({ name: "demandmain", query: { id } });
      location.reload();
    },
    toProduct(id) {
      this.$router.push({ name: "productList", query: { categoryId: id } });
      location.reload();
    },
    transinit() {
      setTimeout(() => {
        // eslint-disable-next-line no-undef
        try {
          new google.translate.TranslateElement(
            {
              // 这个参数不起作用，看文章底部更新，翻译面板的语言
              pageLanguage: "en",
              // 这个是你需要翻译的语言，比如你只需要翻译成越南和英语，这里就只写en,vi
              // includedLanguages: 'de,hi,lt,hr,lv,ht,hu,zh-CN,hy,uk,mg,id,ur,mk,ml,mn,af,mr,uz,ms,el,mt,is,it,my,es,et,eu,ar,pt-PT,ja,ne,az,fa,ro,nl,en-us,en,en-GB,no,be,fi,ru,bg,fr,bs,sd,se,si,sk,sl,ga,sn,so,gd,ca,sq,sr,kk,st,km,kn,sv,ko,sw,gl,zh-TW,pt-BR,co,ta,gu,ky,cs,pa,te,tg,th,la,cy,pl,da,en',
              includedLanguages: "zh-CN,ar,en,es,pt,de,fr,ru,it,ja,vi",
              // 选择语言的样式，这个是面板，还有下拉框的样式，具体的记不到了，找不到api~~
              // eslint-disable-next-line no-undef
              layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
              // 自动显示翻译横幅，就是翻译后顶部出现的那个，有点丑，这个属性没有用的话，请看文章底部的其他方法
              autoDisplay: false,
              // 还有些其他参数，由于原插件不再维护，找不到详细api了，将就了，实在不行直接上dom操作
            },
            "trans" // 触发按钮的id
          );
          // let cookie = Cookies.get('googtrans');
          // if(cookie == '/en/en'){
          // 	document.getElementsByClassName('goog-te-menu-value')[0].children[1].innerHTML = 'English'
          // }
        } catch (e) {
          //TODO handle the exception
          console.info(e);
        }
        // document.getElementsByClassName('goog-te-gadget-icon')[0].remove()
        // document.getElementsByClassName('goog-te-menu-value')[0].remove()
      }, 2000);
    },
    sidemenushow() {
      this.$bus.$emit("sidemenu", true);
    },
    getunread() {
      this.request({
        method: "get",
        url: "/gci/notification/unread",
      })
        .then((res) => {
          this.unreadcount = res.data;
        })
        .catch((error) => {
          console.error(error.response);
        });
    },
    getindex() {
      this.request({
        url: "/gci/index",
        method: "get",
      })
        .then((res) => {
          this.indexdata = res.data.contactUs;
        })
        .catch((error) => {
          console.error(error.response);
        });
    },
    getdemand() {
      this.request({
        method: "get",
        url: "/gci/demand/classify",
      })
        .then((res) => {
          this.demanddata = res.data.items;
        })
        .catch((error) => {
          console.error(error.response);
        });
    },
  },
  mounted() {
    this.isMobile = localStorage.getItem("isMobile");
    console.info("isMobile", this.isMobile);
    window.addEventListener("scroll", this.handleScroll, true);

    this.$bus.$on("totop", (value) => {
      if (value) {
        this.toTop();
      }
    });
    this.$bus.$on("totopshow", (value) => {
      this.totopshow = value;
    });
    this.getindex();
    this.getdemand();
    this.getdata();
    if (localStorage.getItem("token")) {
      this.islogin = true;
      this.getuser();
      this.getunread();
      // this.user = JSON.parse(localStorage.getItem('user'))
      // console.info(this.user)
    }
    // this.transinit()

    loadJs(
      "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
    ).then(() => {
      this.transinit();
    });
  },
};
</script>

<style scoped lang="scss">
input::-webkit-input-placeholder {
  color: #fff;
}

.search-box-input {
  color: #fff !important;
}

.avatar {
  width: 2.2rem;
  height: 2.2rem;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  border-radius: 50%;
}

.edituser {
  width: 2.5rem;
  height: 1.2rem;
  background-color: #31ffda;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.5rem;
  border-radius: 0.2rem;
  color: #000;
}

.edit-user-li {
  display: flex;
  align-items: center;
  margin-top: 0.8rem;
}

.edit-user-li:hover {
  color: #00e8be;
}

.edit-user-li-left {
  display: flex;
  align-items: center;
  flex: 1;
  cursor: pointer;
}

.edit-user-icon {
  width: 1rem;
  height: 1rem;
  margin-right: 0.5rem;
}

.title-top {
  // width: 9rem !important;;
  font-size: 0.9rem;

  .arrow-down {
    width: 1.3rem;
    height: 1.3rem;
    margin-left: 0.3rem;
  }
}

.item-box {
  background-color: #fff;
  border-radius: 0.75rem;
  padding: 1rem 2rem 1rem 1rem;
  box-shadow: 1px 3px 2px 1px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  // width:17rem;
  line-height: 1.5;
  margin-top: 2rem;
  position: absolute;
  left: 0;
  top: 0rem;

  .item-title {
    border-left: 0.25rem solid #31ffda;
    padding-left: 0.75rem;
    margin-bottom: 0.7rem;
    font-size: 1rem;
    color: #000;
    line-height: 1;
    // cursor: pointer;
  }

  .item-text {
    margin-left: 1rem;
    font-size: 0.8rem;
    margin-top: 0.5rem;
    color: #333;
    cursor: pointer;
  }
}

.item-text:hover {
  color: #00e8be;
  font-weight: 600;
}

.bg {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  z-index: 999;
}

.header {
  display: flex;
  justify-content: center;
  padding: 0.5rem 0;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.17);
  // background: linear-gradient(180deg, #000 0%, transparent 100%);
  // background-color: rgba(28, 31, 36, 0.6);
}

.logo {
  width: 13.75rem;
  height: 3.75rem;
  margin-left: 2.125rem;
  cursor: pointer;
}

.logo-top {
  width: 10rem;
  height: 3rem;
  margin-left: 2.125rem;
}

.lang-icon {
  width: 22px;
  height: 22px;
  margin-left: 22px;
  margin-right: 11px;
}

.lang-text {
  font-size: 1.375rem;
  font-family: Inter-Regular, Inter;
  font-weight: 400;
  color: #ffffff;
  line-height: 0px;
}

.icon-down {
  width: 22px;
  height: 22px;
}

.login-button {
  // width: 6rem;
  // height: 2.2rem;
  border-radius: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
  /* font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi; */
  font-weight: 500;
  color: #000000;
  padding: 0.4rem 0.8rem;
}

.title {
  margin-top: 1.5rem;
  display: flex;
  align-items: baseline;
  justify-content: center;
  font-size: 1.2rem;
  /* font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi; */
  font-weight: 500;
  color: #fff;
  line-height: 0px;
  left: 15rem;
  top: 0rem;
}

.title-text {
  // margin: 0 1rem;
  display: flex;
  // align-items: center;
  justify-content: center;
  flex-direction: column;
  // width: 14rem;
  margin: 0 1rem;
  // max-width: fit-content;
  position: relative;
  // height: 3rem;
  padding-bottom: 3rem;
}

.arrow-down {
  width: 26px;
  height: 26px;
  margin-left: 5px;
}

.title-color {
  color: #00e8be !important;
}

.lang-box-text {
  color: #000;
  font-weight: 600;
  font-size: 1rem !important;
}

.mobile-bg {
  display: none;
}

.bg {
  display: block;
}

@media (max-width: 767px) {
  .bg {
    display: none;
  }

  .mobile-bg {
    display: block;

    .slider-title {
      color: #fff;
      font-size: 1.2rem;
      // padding: 0.5rem;
      display: flex;
      align-items: center;
      margin-top: 1rem;
    }

    .item-title {
      color: #fff;
      margin-top: 1rem;
      font-size: 1rem;
      margin-left: 1rem;
    }

    .slider-item {
      display: flex;
      flex-direction: column;
    }
  }

  .menu-box {
    animation-duration: 0.2s;
  }

  .menu-icon-inner {
    background: #fff !important;
  }

  .menu-icon-inner::before {
    background: #fff !important;
  }

  .menu-icon-inner::after {
    background: #fff !important;
  }
}
</style>
